import { AutogenModelEdiCrossRefHandlingRequirement, AutogenRowEdiCrossRefHandlingRequirement } from "./autogen/AutogenModelEdiCrossRefHandlingRequirement";

export class ModelEdiCrossRefHandlingRequirement extends AutogenModelEdiCrossRefHandlingRequirement<RowEdiCrossRefHandlingRequirement> {
	constructor() {
		super(RowEdiCrossRefHandlingRequirement);
	}
}

export class RowEdiCrossRefHandlingRequirement extends AutogenRowEdiCrossRefHandlingRequirement {
}